import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("@/features/student-view/home"));

export const homeRoutes: RouteObject[] = [
  {
    index: true,
    element: <HomePage />,
  },
];
